import React from "react";
import { Switch, Route } from "react-router-dom";


import { PracticesDebtsProvider } from "../contexts/practices-debts-context";
import { CustomerProvider } from "../contexts/customer-context";
import { BanksProvider } from "../contexts/banks-context";
import { CommentsProvider } from "../contexts/comments-context";
import { UserProvider } from "../contexts/user-context";
import { ServiceCustomerProvider } from "../contexts/service-customer-context";
import { ServiceProvider } from "../contexts/service-context";
import { FilesProvider } from "../contexts/files-context";
import ListPracticesErogation from "../components/practices-erogation/list-practices-erogation/list-practices-erogation";

const PracticesErogation = ({ match }) => {
  return (
    <div className="practices-erogation">
      <PracticesDebtsProvider>
        <CustomerProvider>
          <CommentsProvider>
            <BanksProvider>
              <UserProvider>
                <ServiceCustomerProvider>
                  <ServiceProvider>
                    <FilesProvider>
                      <Switch>
                        <Route
                          exact
                          path={`${match.path}`}
                          component={ListPracticesErogation}
                        />
                      </Switch>
                    </FilesProvider>
                  </ServiceProvider>
                </ServiceCustomerProvider>
              </UserProvider>
            </BanksProvider>
          </CommentsProvider>
        </CustomerProvider>
      </PracticesDebtsProvider>
    </div>
  );
};

export default PracticesErogation;
